/**
 * Converts a string to sentence case (first letter capitalized, rest lowercase).
 * @param {string} text
 * @returns {string}
 */
export function sentenceCase(text) {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}
